import { StatusCell } from '../../../components/module-elements/PolicyTable/StatusCell';
import { Skeleton } from '../../../components/ui/skeleton';
import type { Policy } from 'korint-sdk';

export function keepSignedStatuses(key: string) {
  return (
    key === 'POLICY_SIGNED' ||
    key === 'ACTIVE_POLICY' ||
    key === 'STOPPED_POLICY' ||
    key === 'SUSPENDED_POLICY'
  );
}

type PolicyStatusProps = {
  policy: Pick<Policy, 'customFields' | 'status'>;
  branchId?: string;
  isLoading?: boolean;
};

export const PolicyStatus = ({ policy, isLoading }: PolicyStatusProps) => {
  if (isLoading) {
    return <Skeleton className="h-6 w-xl" />;
  }

  const statusKey = (policy.customFields?.customStatus ?? policy.status) as string;

  return <StatusCell value={statusKey} />;
};
